import React from 'react';
import Header from './Header';
import Footer from './Footer';
import CustomCursor from '../ui/CustomCursor';
import Chatbot from '../Chatbot';

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col bg-[#FFFBF5] custom-cursor-zone">
      {/* Custom Animated Cursor */}
      <CustomCursor />
      
      {/* Subtle Sand Texture */}
      <div className="fixed inset-0 pointer-events-none z-0 sand-texture opacity-50" />
      
      <Header />
      <main className="flex-1 relative z-10">
        {children}
      </main>
      <Footer />
      
      {/* AI Chatbot */}
      <Chatbot />
    </div>
  );
};

export default Layout;
